/* eslint-disable no-restricted-imports, react/forbid-elements */
import type { LinkProps } from "next/link";
import Link from "next/link";

type Props = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> &
	LinkProps & {
		children?: React.ReactNode;
	} & React.RefAttributes<HTMLAnchorElement>;

export const SiteLink = ({ children, href, ...props }: Props) => {
	const isAbsolute = href?.toString()?.match(/^\w+\:/);

	if (isAbsolute) {
		return (
			<Link
				href={href}
				{...props}
			>
				{children}
			</Link>
		);
	}

	return (
		<Link
			{...props}
			href={`${href?.toString()?.startsWith("/") ? "" : "/"}${href}`}
		>
			{children}
		</Link>
	);
};

export default SiteLink;
